import { CartProduct } from 'cart'
import { AvailabilityErrorType } from 'interfaces'

export const hasOutOfStockError = (product: CartProduct): boolean =>
  product.errors?.filter(
    (e) => e.errorType === AvailabilityErrorType.OUT_OF_STOCK_ALL_LOCATIONS
  )?.length > 0

export const hasNonPrimaryLocationError = (product: CartProduct): boolean =>
  !!product.errors?.find(
    (e) => e.errorType === AvailabilityErrorType.ORDER_FROM_NON_PRIMARY_LOCATION
  )
